import { reportConstants } from '../constants';

export function reportReducers(state = {}, action) {
    switch (action.type) {
            
        // Get Outlet Reports
        
        case reportConstants.getOutletReports_request:
            return {
                ...state,
                getOutletReports_requesting: true, getOutletReports_status: false,
            }
        case reportConstants.getOutletReports_success:
            return {
                ...state,
                getOutletReports_requesting: false, getOutletReports_status: true,
                outletReports: action.details.data,
                outletReportsHeader: action.details.headers
            }
        case reportConstants.getOutletReports_failure:
            return {
                ...state,
                getOutletReports_requesting: false, getOutletReports_status: false, 
            }

        default:
            return state;
    }
}